export const messages = {
    "shared-link.footer.link.install": "免費試用 {brandName}",
    "shared-link.footer.link.mobile": "{brandName} 行動版",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "受​保護的資料",
    "shared-link.password-dialog-box.message": "請指定存取共用資料的密碼",
    "shared-link.password-dialog-box.hint.password": "密碼",
    "shared-link.password-dialog-box.message.invalid-password": "密碼不正確",
    "shared-link.form.button.open": "開啟",
    "shared-link.page-not-found.title": "找不到頁面",
    "shared-link.page-not-found.message.main": "找不到您要尋找的頁面。",
    "shared-link.page-not-found.message.description": "此連結可能過時，或者您可以輸入錯誤的位址。",
    "shared-link.page-not-found.message.error": "錯誤碼:404",
    "shared-link.restore-file.label.size": "大小",
    "shared-link.restore-file.button.restore": "下載",
    "shared-link.links-table.column.name": "名稱",
    "shared-link.links-table.column.size": "大小",
    "shared-link.links-table.action.restore": "下載",
    "shared-link.links-table.action.restore-all": "全部下載",
    "shared-link.side-bar.selected.title:plural": "已選擇 {count} 個項目 | 已選擇 {count} 個項目",
    "shared-link.links-table.label.size": "大小",
    "shared-link.links-table.message.empty-folder": "此資料夾是空的"
};
